require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-gmj-matter-goodbar.json") })
        }
      }, "path---interview-gmj-matter-goodbar");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-gmj-matter-goodbar!./.cache/json/interview-gmj-matter-goodbar.json
// module id = 676
// module chunks = 231608221292675